import CloseIcon from '@mui/icons-material/Close';
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from '@mui/material';
import React from 'react';

const DeleteTagDialog = ({
  open,
  onClose,
  onConfirm,
  tag,
  isDeleting,
  affectedMealCount = 0,
  isLoadingAffectedMeals = false,
}) => {
  const hasAffectedMeals = affectedMealCount > 0;

  return (
    <Dialog
      open={open}
      onClose={isDeleting ? undefined : onClose}
      fullWidth
      maxWidth='xs'
    >
      <DialogTitle sx={{ pr: 7 }}>
        Delete tag
        <IconButton
          onClick={onClose}
          disabled={isDeleting}
          sx={{ position: 'absolute', right: 16, top: 12 }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant='s16_w500'>
          Are you sure you want to delete{' '}
          <strong>{tag?.nameEn ?? 'this tag'}</strong>?
        </Typography>
        <Typography variant='s16_w500' mt={2} color='#6B7280'>
          {isLoadingAffectedMeals
            ? 'Checking whether this tag is currently assigned to any food boxes.'
            : hasAffectedMeals
            ? `This tag is currently assigned to ${affectedMealCount} food box${
                affectedMealCount === 1 ? '' : 'es'
              }. Deleting it will remove the tag from those food boxes as well.`
            : 'This tag is not currently assigned to any add-ons or catering meals.'}
        </Typography>
      </DialogContent>
      <DialogActions sx={{ px: 3, pb: 3 }}>
        <Button variant='outlined' onClick={onClose} disabled={isDeleting}>
          Cancel
        </Button>
        <Button
          color='error'
          variant='contained'
          onClick={onConfirm}
          disabled={isDeleting}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteTagDialog;
